import { gql } from "@grandvisionhq/graphql";
const NearestStoreFragment = gql`
  fragment NearestStore on Store {
    code
    globalStoreId
    slug
    town
    shortName
    storeDetailImage
    distance
    breadcrumbName
    breadcrumbSlug
  }
`;
export {
  NearestStoreFragment as default
};
//# sourceMappingURL=nearest-store.js.map
